export default {
  slogan: "<0>ON S'INVESTIT,</0> <0>POUR VOUS.</0>",
};
